import React from "react";

import { ButtonStandard } from "@performyard/py-components";

type BulkEditToggleButtonProps = {
	editMode: boolean;
	manageLabel: string;
	editingLabel: string;
	// Callers pass isSaving: exiting mid-save would "discard" edits the in-flight PATCH still commits.
	disabled?: boolean;
	onEnter: () => void;
	onRequestExit: () => void;
};

// Persistent mode toggle for bulk level editing (PY-14092): one button that changes label and
// emphasis instead of being swapped for a Save/Cancel cluster, so the toolbar never reflows.
// Exiting through it while dirty goes through the same confirm as the bar's Cancel.
export const BulkEditToggleButton = ({
	editMode,
	manageLabel,
	editingLabel,
	disabled = false,
	onEnter,
	onRequestExit,
}: BulkEditToggleButtonProps): React.ReactElement =>
	editMode ? (
		<ButtonStandard
			color="neutral"
			variant="outline"
			onClick={onRequestExit}
			disabled={disabled}
			data-testid="bulk-edit-toggle"
		>
			{editingLabel}
		</ButtonStandard>
	) : (
		<ButtonStandard color="primary" onClick={onEnter} disabled={disabled} data-testid="bulk-edit-toggle">
			{manageLabel}
		</ButtonStandard>
	);
